import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        auth: null,
        callByAli: window.callByAli,
        initialInfo: {},
        currentSearchForm: {},
        // -1 未注册, 0 注册中，1 离线，2 小休，3 空闲，5 话后处理，6 振铃，8 拨号中，9 呼入通话，10 呼出通话，12 通话保持
        callState: -1,
        DXCallState: -1,
        //快捷外呼号码
        want2call: null,
        // 来电或去电信息，包含 caller/callee/inout(in/out)/dialing(true/false)
        callInfo: {},
        handleClearcall: {},
        get oneOlder() {
            return JSON.parse(sessionStorage.getItem("oneOlder"))
        },
        set oneOlder(value) {
            sessionStorage.setItem("oneOlder", JSON.stringify(value))
        }
    },
    actions,
    // getters,
    mutations
})